import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
  Col,
} from "reactstrap";
import Select from "react-select";
import {
  resourcesRoutes,
  resourcesFuelSales,
  getUnitsWithOperators,
  getUnitsDataDeposit,
  resourcesDeposits,
} from "../../../helpers/backend_helper";
import { useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import NibbleInput from "../../../components/Fields/NibbleInput";

const formatter = new Intl.NumberFormat("es-MX", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const AddUpdModal = ({
  modal,
  setModal,
  items,
  setItems,
  item,
  selects
}) => {
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    route_id: null,
    select: true,
  });
  let params = { params: filters };
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...item},
    validationSchema: Yup.object({
      unit_id: Yup.string().nullable(true).required("Requerido"),
      operator_id: Yup.string().nullable(true),
      date: Yup.date().nullable(true).required("Requerido"),
      amount: Yup.number().nullable(true).min(0.01).required("Requerido"),
      total: Yup.string().nullable(true).required("Requerido"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      await save(values);
    },
  });

  const save = (values) => {
    let method = modal.update ? "put" : "post";
    resourcesDeposits(method, values, modal.update ? item.id : null).then(
      (response) => {
        setLoading(true);
        responseAction(response);
        setLoading(false);
      }
    );
  };

  const responseAction = (response) => {
    if (response.status) {
      const newItem = response.deposit;
      let array = [];
      if (modal.update) {
        array = items.map((item) => (item.id !== newItem.id ? item : newItem));
      } else {
        array = [...items, newItem];
        array.sort((a, b) => {
          return a.id - b.id;
        });
      }
      setItems(array);
      handleClose();
    } else {
      setErrors(response.response.data.errors);
    }
  };

  useEffect(() => {
    const getDataUnit = () => {
      getUnitsDataDeposit({params: {unit_id: validation.values.unit_id, date: validation.values.date }}).then((data) => {
        validation.setFieldValue('imprevisto', data.imprevisto)
        validation.setFieldValue('salidas_count', data.salidas)
      });
    }

    if(validation.values.unit_id && !modal.update) {
      let operator = selects.operators.filter(e=>e.unit_id == validation.values.unit_id)
      operator = operator.length > 0 ? operator[0]:null
      if(operator)
        validation.setFieldValue('operator_id', operator.id)
      getDataUnit()
    }
      
  }, [validation.values.unit_id]);

  useEffect(() => {
    console.log(validation.values.notes, validation.values.amount)
    let total = 0
    if(validation.values.notes, validation.values.amount) {
      total = Number(validation.values.notes) + Number(validation.values.amount)
      total = total ?? 0
    }
    validation.setFieldValue(
      "total",
      total
    );
  }, [validation.values.notes, validation.values.amount]);

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar" : "Agregar"} Depósito
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              
              <NibbleInput
                md={6}
                label="Unidad / Camión:"
                fieldName="unit_id"
                fieldType="select"
                selectItems={selects.units}
                selectOptionLabel={(e) => e.number}
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Fecha:"
                fieldName="date"
                fieldType="date"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Imprevisto:"
                fieldName="imprevisto"
                fieldType="text"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Operador:"
                fieldName="operator_id"
                fieldType="select"
                selectItems={selects.operators}
                selectOptionLabel={(e) => e.full_name}
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Efectivo:"
                fieldName="amount"
                fieldType="number"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Vueltas:"
                fieldName="salidas_count"
                fieldType="number"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Notas:"
                fieldName="notes"
                fieldType="number"
                validation={validation}
              />
              
              <Col md={6}></Col>

              <NibbleInput
                md={6}
                disabled={true}
                label="Total:"
                fieldName="total"
                fieldType="text"
                validation={validation}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
